import { pathOr, pipe, prop, toLower, __ } from 'ramda'
import { utils } from '@digital-commerce/shared-utils'

import { isAffiliateFlow } from '../../../utils/cart'

const { isMobilityEppCart } = utils.cart

export const HeaderTypes = {
  PERSONAL: 'personal',
  EPP: 'epp',
  SMALLBUSINESS: 'business-small',
  BUSINESS: 'business',
  SIMPLE: 'simple-header',
  TWA_LEGACY: 'twa-legacy',
  AFFILIATE: 'affiliates'
}

export const FooterTypes = {
  PERSONAL: 'personal',
  SMALLBUSINESS: 'business-small',
  SIMPLE: 'simple-footer',
  CLEAN: 'dc-footer-clean'
}

export const getHeaderFooterType = (cart) => {
  const defaultHeaderFooter = {
    header: HeaderTypes.PERSONAL,
    footer: FooterTypes.PERSONAL
  }

  const translateCustomerHeaderFooter = {
    epp: {
      header: HeaderTypes.EPP,
      footer: FooterTypes.PERSONAL
    },
    personal: defaultHeaderFooter,
    business: {
      header: HeaderTypes.SMALLBUSINESS,
      footer: FooterTypes.SMALLBUSINESS
    },
    twa_legacy: {
      header: HeaderTypes.TWA_LEGACY,
      footer: FooterTypes.PERSONAL
    },
    affiliate: {
      header: HeaderTypes.AFFILIATE,
      footer: FooterTypes.PERSONAL
    }
  }

  if (isMobilityEppCart(cart)) {
    return translateCustomerHeaderFooter.epp
  }

  if (isAffiliateFlow(cart)) {
    return translateCustomerHeaderFooter.affiliate
  }

  const _marketType = pipe(
    pathOr('CONSUMER', ['root', 'market', 'type']),
    toLower
  )

  const _getValueKey = prop(__, translateCustomerHeaderFooter)

  const market = _marketType(cart)

  if (!_getValueKey(market)) return defaultHeaderFooter

  return _getValueKey(market)
}
